import React from 'react';
import './LoadingSpinner.css'; // Ensure you have this CSS file for styling
const LoadingSpinner = () => (
    <div className='spinner-style'>
    <div class='bounce-container'>
      <div class='ball'></div>
      
    </div>
    </div>
);

export default LoadingSpinner;
